import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }            from '../shared/shared.module';
import { StripeCheckoutComponent } from './stripe.checkout.component';
import { StripePaymentComponent }  from './stripe.payment.component';
import { StripeService }           from './stripe.service';
import { StripeSettingsComponent } from './stripe.settings.component';
import { StripeStates }            from './stripe.states';
import { StripeStatusPipe }        from './stripe.status.pipe';

@NgModule({
  declarations: [
    StripeCheckoutComponent,
    StripePaymentComponent,
    StripeSettingsComponent,
    StripeStatusPipe
  ],
  entryComponents: [
    StripeCheckoutComponent,
    StripePaymentComponent
  ],
  exports: [
    StripeCheckoutComponent,
    StripePaymentComponent
  ],
  imports: [
    SharedModule,
    UIRouterUpgradeModule.forChild({ states: StripeStates })
  ],
  providers: [
    StripeService,
    StripeStatusPipe
  ]
})
export class StripeModule {}